<div cdkDrag [cdkDragData]="data">
  <div [ngClass]="data.placeholderClassName" *cdkDragPlaceholder></div>
  <div
    [id]="data.id"
    class="widget-area"
    [ngClass]="data.isSelected ? 'widget-selected' : 'widget-unselected'"
    cdkDropList
    [cdkDropListConnectedTo]="dropListIds"
    [cdkDropListData]="data.children"
    [cdkDropListEnterPredicate]="isDroppableWidget"
    (cdkDropListDropped)="onDrop($event)"
  >
    <!-- Titlebar for Widget -->
    <div *ngIf="!isMetadataView()" class="widget-top-bar" fxLayout="row nowrap" fxLayoutAlign="end start">
      <mat-icon class="drag-handler" cdkDragHandle>drag_indicator</mat-icon> 
      <mat-label fxFlex="grow" title="{{ data.id }}" (click)="onSelect()"><b>{{ data.key }}</b><b *ngIf="data.label"> [{{data.label}}]</b></mat-label>
      <!-- <mat-icon *ngIf="data.isSelected" class="top-icon" (click)="onSelect()">check</mat-icon>       -->
      <img src="assets/img/icons/time-range.png">
      <mat-icon class="top-icon" (click)="onDeleteModal()">delete</mat-icon>
      <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMinimize()">minimize</mat-icon>
      <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMaximize()">settings</mat-icon>
      <!-- <mat-icon class="drag-handler" cdkDragHandle [matBadge]="data.badge">{{ data.icon }}</mat-icon> -->
    </div>

    <!-- Config data for Widget -->
    <div *ngIf="!isMinimized">
      <app-metadata-timerange [data]="data"></app-metadata-timerange>     
    </div>
    
    <!--<div *ngIf="!isMinimized" class="widget-config" fxLayout="column wrap">
      <h5 *ngIf="!isMinimized">Validations:</h5>      
      <ng-container *ngFor="let widget of data.children">
        <ng-container [ngSwitch]="widget.widgetType">
          <div
            appValdnWidgetsComparison
            [data]="$any(widget)"
            *ngSwitchCase="WidgetsTypeEnum.VALDN_COMP"
          ></div>
          <div
            appValdnWidgetsDate
            [data]="$any(widget)"
            *ngSwitchCase="WidgetsTypeEnum.VALDN_DATE"
          ></div>
          <div
            appValdnWidgetsIP
            [data]="$any(widget)"
            *ngSwitchCase="WidgetsTypeEnum.VALDN_IP"
          ></div>
        </ng-container>
      </ng-container>
    </div>-->
  </div>
</div>
